module.exports = __webpack_public_path__ + "static/img/Best.341bccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Best.png
// module id = kSsQ
// module chunks = 52